module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "data-container"
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('h3', [_vm._v("订单客户信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "customerId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "readonly": ""
    },
    model: {
      value: (_vm.addForm.customerId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "customerId", $$v)
      },
      expression: "addForm.customerId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户来源"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "readonly": ""
    },
    model: {
      value: (this.customerSource),
      callback: function($$v) {
        _vm.$set(this, "customerSource", $$v)
      },
      expression: "this.customerSource"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户级别"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "readonly": ""
    },
    model: {
      value: (this.customerLabel),
      callback: function($$v) {
        _vm.$set(this, "customerLabel", $$v)
      },
      expression: "this.customerLabel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户销售渠道"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "readonly": ""
    },
    model: {
      value: (this.customerType),
      callback: function($$v) {
        _vm.$set(this, "customerType", $$v)
      },
      expression: "this.customerType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("订单数据")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "orderSn"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.orderSn))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货仓库",
      "prop": "stash"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "placeholder": "请输入发货仓"
    },
    model: {
      value: (_vm.addForm.stash),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "stash", $$v)
      },
      expression: "addForm.stash"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('h3', [_vm._v("产品信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-s-goods",
      "plain": ""
    },
    on: {
      "click": _vm.showProductDialog
    }
  }, [_vm._v("选择产品")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.productList,
      "border": true
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "width": "100",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "picture",
      "label": "产品图片",
      "width": "130",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "100px",
            "height": "100px"
          },
          attrs: {
            "src": scope.row.picture,
            "preview-src-list": [scope.row.picture],
            "alt": "Product Image"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "产品价格",
      "width": "100",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costPrice",
      "label": "成本价",
      "width": "100",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productStock.stock",
      "label": "库存",
      "width": "100",
      "align": 'center'
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "采购数量(箱)",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "size": "mini",
            "min": 0,
            "controls": false,
            "value": scope.row.purchaseQuantity || 0
          },
          on: {
            "change": function($event) {
              return _vm.calculateOrderAmount(scope.row)
            }
          },
          model: {
            value: (scope.row.purchaseQuantity),
            callback: function($$v) {
              _vm.$set(scope.row, "purchaseQuantity", $$v)
            },
            expression: "scope.row.purchaseQuantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salePrice",
      "label": "成交价(元)",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "size": "mini",
            "min": 0,
            "controls": false,
            "value": scope.row.salePrice || 0.00
          },
          on: {
            "change": function($event) {
              return _vm.calculateOrderAmount(scope.row)
            }
          },
          model: {
            value: (scope.row.salePrice),
            callback: function($$v) {
              _vm.$set(scope.row, "salePrice", $$v)
            },
            expression: "scope.row.salePrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额(元)",
      "width": "110",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.calculateOrderAmount(scope.row)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.cancelshowData(scope.row.id, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "left",
      "font-weight": "bold"
    }
  }, [_vm._v("\n        订单总金额: " + _vm._s(_vm.totalOrderAmount.toFixed(2)) + " 元\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "left",
      "font-weight": "bold"
    }
  }, [_vm._v("\n        总采购数量: " + _vm._s(_vm.purchaseNum) + " 箱\n      ")]), _vm._v(" "), _c('h3', [_vm._v("物流信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "快递公司",
      "prop": "logisticsCompanies"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "placeholder": "请输入快递公司"
    },
    model: {
      value: (_vm.addForm.logisticsCompanies),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "logisticsCompanies", $$v)
      },
      expression: "addForm.logisticsCompanies"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流单号",
      "prop": "trackingNumber"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "placeholder": "请输入快递单号,也可以后续在输入"
    },
    model: {
      value: (_vm.addForm.trackingNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "trackingNumber", $$v)
      },
      expression: "addForm.trackingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "快递备注",
      "prop": "notes"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "remarks", $$v)
      },
      expression: "addForm.remarks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单备注",
      "prop": "notes"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.notes),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "notes", $$v)
      },
      expression: "addForm.notes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货方式",
      "prop": "logisticsMethods"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "clearable": "",
      "placeholder": "请选择或手动输入发货方式"
    },
    model: {
      value: (_vm.addForm.logisticsMethods),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "logisticsMethods", $$v)
      },
      expression: "addForm.logisticsMethods"
    }
  }, _vm._l((_vm.ShippingMethod), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "选择框不满足时,可以自己手动输入"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货地址",
      "prop": "shippingAddress"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.shippingAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "shippingAddress", $$v)
      },
      expression: "addForm.shippingAddress"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "10px",
      "display": "flex",
      "align-items": "flex-start"
    },
    attrs: {
      "span": 4
    }
  }, [_c('addressSelector', {
    attrs: {
      "customer-id": _vm.customerId
    },
    model: {
      value: (_vm.addForm.shippingAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "shippingAddress", $$v)
      },
      expression: "addForm.shippingAddress"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('h3', [_vm._v("收款信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款方式",
      "prop": "payType"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入收款方式"
    },
    model: {
      value: (_vm.addForm.payType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "payType", $$v)
      },
      expression: "addForm.payType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付状态",
      "prop": "paymentStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "已支付",
      "border": ""
    },
    model: {
      value: (_vm.addForm.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "paymentStatus", $$v)
      },
      expression: "addForm.paymentStatus"
    }
  }, [_vm._v("已支付")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "欠款",
      "border": ""
    },
    model: {
      value: (_vm.addForm.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "paymentStatus", $$v)
      },
      expression: "addForm.paymentStatus"
    }
  }, [_vm._v("欠款")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款凭证",
      "prop": "receipt"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "file",
      "action": this.$uploadURL,
      "on-remove": _vm.handleFileRemove,
      "on-success": _vm.handleFileUpload,
      "on-exceed": _vm.handleFileExceed,
      "multiple": true,
      "limit": 5,
      "file-list": _vm.fileList,
      "accept": ".jpg,.png,.gif",
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单审核人",
      "prop": "orderReviewerId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择审核人!"
    },
    model: {
      value: (_vm.addForm.orderReviewerId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "orderReviewerId", $$v)
      },
      expression: "addForm.orderReviewerId"
    }
  }, _vm._l((this.examines), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.adminName,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("创建订单")])], 1)], 1), _vm._v(" "), _c('ProductSelect', {
    attrs: {
      "visible": _vm.productFormVisible,
      "selected-products-from-parent": _vm.productList
    },
    on: {
      "update:visible": function($event) {
        _vm.productFormVisible = $event
      },
      "upload-products": _vm.handleUploadProducts
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd6d71c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerMag/CustomeraAddorder.vue
// module id = 1039
// module chunks = 3